import { useState } from 'react';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonWithTooltip,
  insertDirective$,
  usePublisher,
} from '@mdxeditor/editor';
import { useTranslation } from 'react-i18next';

import type { IYouTubeMdxDirectiveDialogFormValues } from './YouTubeMdxDirectiveDialogForm';
import { YOUTUBE_MDX_DIRECTIVE_NAME } from './youTubeMdxDirectiveConstants';
import { YouTubeMdxDirectiveDialogForm } from './YouTubeMdxDirectiveDialogForm';

export type IYouTubeMdxDirectiveToolbarButtonProps = Record<string, never>;

export type IYouTubeMdxDirectiveAttributes = {
  id: string;
};

export const YouTubeMdxDirectiveToolbarButton: React.FC<
  IYouTubeMdxDirectiveToolbarButtonProps
> = () => {
  const insertDirective = usePublisher(insertDirective$);
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = (values: IYouTubeMdxDirectiveDialogFormValues): void => {
    setOpened(false);

    const url = new URL(values.url ?? '');
    const videoId = url.searchParams.get('v') ?? '';

    const attributes: IYouTubeMdxDirectiveAttributes = {
      id: videoId,
    };

    insertDirective({
      name: YOUTUBE_MDX_DIRECTIVE_NAME,
      type: 'leafDirective',
      attributes,
    });
  };

  return (
    <>
      <YouTubeMdxDirectiveDialogForm
        opened={opened}
        onClose={() => setOpened(false)}
        onSubmit={handleSubmit}
      />

      <ButtonWithTooltip
        title={t('YouTubeMdxDirectiveToolbarButton.tooltip')}
        onClick={() => setOpened(true)}
      >
        <FontAwesomeIcon
          icon={faYoutube}
          fontSize={18}
          style={{ padding: 3 }}
        />
      </ButtonWithTooltip>
    </>
  );
};
